import React from 'react';

import phpVars from 'phpVars';

import './css/app.scss';

import 'react-responsive-modal/styles.css';

import UsersPage from "./User/UsersPage";
import UserEditForm from "./User/ReactUserEditForm";
import UpdateProgressReviewPage from "./ProgressReview/UpdateProgressReviewPage";
import OutcomeReviewSchedulingPage from "./Outcomes/OutcomeReviewSchedulingPage";
import ProgressReviewSchedulingPage from "./ProgressReview/ProgressReviewSchedulingPage";
import DesignatedTeacherForm from "./School/DesignatedTeacherForm";
import LoginForm from "./Login/ReactLoginForm";
import ChildBasicHeaderForm from "./Pep/ChildBasicHeaderForm";
import TabbedWorkflowSocialWorkerFeedback from "./Pep/ReactTabbedWorkflowSocialWorkerFeedback";
import UpdateOutcomesPage from "./Outcomes/ReactUpdateOutcomesPage";
import SchoolDetailForm from "root/School/SchoolDetailForm";

import SessionProvider from "root/Contexts/SessionProvider";
import ChildProvider from "root/Contexts/ChildProvider";

import './Tables/Table.scss' ;
import './Tables/PassportTable.scss' ;
import CreateChild3 from "root/NewToLAC/CreateChild3";
import {createRoot} from "react-dom/client";

const MyApp = ( {dataset} ) =>
{
    const renderComponent = () =>
    {
        switch ( phpVars.div )
        {
            case 'new-child-div':
                return (
                    <SessionProvider dataset={dataset}>
                       <ChildProvider child_id={null}>
                           <CreateChild3  />
                       </ChildProvider>
                   </SessionProvider>
            );

/*
            case 'create-pep-div':
                return (
                    <TabbedWorkflowCreatePEP2
                        child_id={phpVars.child_id}
                        user_id={phpVars.user_id}
                        user_type={phpVars.user_type}
                        mode={phpVars.mode}
                        return_url={phpVars.return_url}
                        title={phpVars.title}
                        workitem_id={phpVars.workitem_id}
                    />);
*/
            case 'users-div':
                return (
                    <SessionProvider dataset={dataset}>
                        <UsersPage usertype={phpVars.usertype}/>
                    </SessionProvider>
                        );
            case 'edit-user-div':
                return (
                    <UserEditForm
                        mode={phpVars.mode}
                        usertype={phpVars.usertype}
                        userid={phpVars.userid}
                        return_url={phpVars.return_url}
                        title={phpVars.title}
                        readonly={phpVars.readonly}
                    />);
            case 'progress-div':
                return (
                    <UpdateProgressReviewPage
                        activePage={phpVars.activePage}
                        child_id={phpVars.child_id}
                        user_type={phpVars.user_type}
                        return_url={phpVars.return_url}
                        review_id={phpVars.review_id}
                        workitem_id={phpVars.workitem_id}
                    />);
            case 'outcome-gen-div':
                return (
                    <OutcomeReviewSchedulingPage
                        return_url={phpVars.return_url}
                    />);
            case 'prog-review-div':
                return (
                    <ProgressReviewSchedulingPage
                        return_url={phpVars.return_url}
                        activePage={phpVars.activePage}
                        child_id={phpVars.child_id}
                        user_type={phpVars.user_type}
                        review_id={phpVars.review_id}
                        workitem_id={phpVars.workitem_id}
                    />);
            case 'schools-div':
                return (
                    <SessionProvider dataset={dataset}>
                    <DesignatedTeacherForm
                        school_group_id={phpVars.school_group_id}
                        user_type={phpVars.user_type}
                        return_url={phpVars.return_url}
                    /></SessionProvider>);
            case 'school-detail-div':
                return (
                    <SessionProvider dataset={dataset}>
                        <SchoolDetailForm
                            school_id={phpVars.school_id}
                            user_type={phpVars.user_type}
                            return_url={phpVars.return_url}
                        />
                    </SessionProvider>
                );
            case 'login-div':
                return (
                    <LoginForm
                        mode={phpVars.mode}
                        user_type={phpVars.user_type}
                        options={phpVars.options}
                        reason={phpVars.reason}
                    />);
            case 'sw-div':
                return (
                    <div className="jumbotron">

                        <p className="med">Provide feedback for pupil</p>

                        <ChildBasicHeaderForm mode='view' child_id={phpVars.child_id}/>
                        <TabbedWorkflowSocialWorkerFeedback
                            return_url={phpVars.return_url}
                            mode='crewte'
                            pep_id={phpVars.pep_id}
                            child_id={phpVars.child_id}
                            activePage={phpVars.activePage}
                            teacher_feedback={true}
                            workitem_id={phpVars.workitem_id}
                        />
                    </div>)

            case 'outcome-div':
                return (
                    <UpdateOutcomesPage
                        child_id={phpVars.child_id}
                        user_id={phpVars.user_id}
                        user_type={phpVars.user_type}
                        ofr_id={phpVars.ofr_id}
                        mode={phpVars.mode}
                        return_url={phpVars.return_url}
                        workitem_id={phpVars.workitem_id}
                    />);
            default:
        }
    }

    return ( renderComponent());
}

const container = document.getElementById(phpVars.div);

const atts = container.dataset;

const root = createRoot(container);
root.render(<MyApp dataset={atts}/>);

